import axios from 'axios'
import storage from '@/utils/storage'

//  过期时重新去调用登陆的接口
export function refreshToken() {
  return new Promise((resolve, reject) => {
    axios({
      method: 'POST',
      url: `/passport/login`,
      data: {
        'login_name': storage.session.get('login_name'),
        'password': storage.session.get('pwd')
      },
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'catch': false
      }
    }).then(res => {
      if (res) {
        resolve(res.data)
      }
    }).catch(err => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/refresh.js